import { useState } from 'react';

export function ReportsPage() {
    const [message, setMessage] = useState('');
    const [chatHistory, setChatHistory] = useState<{ role: 'user' | 'ai'; text: string }[]>([]);
    const [loading, setLoading] = useState(false);

    async function handleSend() {
        if (!message.trim()) return;
        const userMsg = message;
        setChatHistory(prev => [...prev, { role: 'user', text: userMsg }]);
        setMessage('');
        setLoading(true);
        try {
            const res = await fetch('/api/reports/generate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt: userMsg }),
            });
            const data = await res.json() as { response?: string };
            setChatHistory(prev => [...prev, { role: 'ai', text: data.response || 'No response' }]);
        } catch {
            setChatHistory(prev => [...prev, { role: 'ai', text: 'Error generating report' }]);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="animate-in">
            <header className="page-header">
                <h1 className="page-title">Medical Reports</h1>
                <p className="page-subtitle">AI-powered clinical interpretation via Med-PaLM 2</p>
            </header>

            <div className="card" style={{ height: 'calc(100vh - 240px)', display: 'flex', flexDirection: 'column' }}>
                <div style={{ flex: 1, overflowY: 'auto', marginBottom: 16 }}>
                    {chatHistory.length === 0 ? (
                        <div style={{ textAlign: 'center', color: 'var(--color-text-dim)', paddingTop: 60 }}>
                            <span style={{ fontSize: 48, display: 'block', marginBottom: 16 }}>💬</span>
                            Ask about variant interpretation, protein function, or clinical significance
                        </div>
                    ) : (
                        chatHistory.map((msg, i) => (
                            <ChatBubble key={i} role={msg.role} text={msg.text} />
                        ))
                    )}
                    {loading && <ChatBubble role="ai" text="Thinking..." loading />}
                </div>
                <div style={{ display: 'flex', gap: 12 }}>
                    <input
                        className="form-input"
                        placeholder="Ask about genomic variants..."
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSend()}
                    />
                    <button className="btn btn-primary" onClick={handleSend} disabled={loading}>
                        Send
                    </button>
                </div>
            </div>
        </div>
    );
}

function ChatBubble({ role, text, loading }: { role: 'user' | 'ai'; text: string; loading?: boolean }) {
    const isUser = role === 'user';
    return (
        <div style={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', marginBottom: 12 }}>
            <div
                style={{
                    maxWidth: '70%',
                    padding: '12px 16px',
                    borderRadius: 'var(--radius-md)',
                    background: isUser ? 'var(--gradient-primary)' : 'var(--color-bg)',
                    color: isUser ? 'white' : 'var(--color-text)',
                }}
                className={loading ? 'animate-pulse' : ''}
            >
                {text}
            </div>
        </div>
    );
}
